import { Translate } from 'next-translate'
import getConfig from 'next/config'

import { TENANTS } from '@/lib/tenants/constants'
import { Tenants } from '@/lib/tenants/types'
import { Potential_Property } from '@/types/cate-graphql-generated-types'
import { getTranslatedStateOfMaintenance } from '@/utils/getTranslatedStateOfMaintenance'

import { CasavoAdvantage } from '../ListingDetail/CasavoAdvantage'
import { Characteristic } from '../ListingDetail/Characteristics'

export const mockedPhotos = [
  {
    isPrimary: false,
    order: 0,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/3ce6144c-15bf-48d7-84c0-18814b6a206b.png',
  },
  {
    isPrimary: false,
    order: 1,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/80ffdcb6-77ee-4823-abcb-cc0c3737e688.jpg',
  },
  {
    isPrimary: false,
    order: 2,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/c06e512f-a4b7-48f0-a175-9e0beb43ea0e.png',
  },
  {
    isPrimary: false,
    order: 3,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/df18382a-90d6-420c-9ed0-20fc2ad74f38.png',
  },
  {
    isPrimary: false,
    order: 4,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/777ae9f0-3c71-47b7-aa9c-91f95d53139c.jpeg',
  },
  {
    isPrimary: false,
    order: 5,
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/6e9a5529-fa6d-4568-b842-ac1eecc354a4.png',
  },
]

export const propertyMock = {
  askedPrice: { cents: 14000000, currency: '€' },
  city: 'it/milano',
  detail: {
    titles: [
      {
        language: 'it',
        text: 'Bilocale di 40m² in Via Elia Lombardini 11',
      },
      {
        language: 'en',
        text: 'Studio of 40m² in Via Elia Lombardini 11',
      },
      {
        language: 'fr',
        text: 'Appartement 2 pièces de 40m² - 20143',
      },
    ],
  },
  id: '9f09c3a5-de86-46bc-bc7b-7ffa3b585d05',
  photos: mockedPhotos,
  planimetries: {
    url: 'https://casavo-nika-media-staging.imgix.net/listing/1174/floorplans/5d132041-4cc2-4cae-b1ef-f751dec27544.png',
  },
  title: 'Bilocale di 40m² in Via Elia Lombardini 11',
  zone: 'Navigli',
}

const iconUrl = (iconName: string, tenant: Tenants) => {
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()
  switch (tenant) {
    case TENANTS.casavo:
      return `${imageBasePath}/images/advantages/${iconName}.svg`
    case TENANTS.ucsc:
      return `${imageBasePath}/images/tenants/ucsc/advantages/${iconName}.svg`
  }
}

const iconSize: Record<Tenants, number> = {
  [TENANTS.casavo]: 80,
  [TENANTS.ucsc]: 48,
}

export const advantagesCTA: (tenant: Tenants) => CasavoAdvantage[] = (tenant) => [
  {
    descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Advance_Description',
    iconUrl: iconUrl('success-small', tenant),
    imageSize: iconSize[tenant],
    titleTranslationKey: 'priority:Priority_DetailPage_FloatingBanner_Bullet1',
  },
  {
    descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Waitlist_Description',
    iconUrl: iconUrl('appointment', tenant),
    imageSize: iconSize[tenant],
    titleTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Waitlist_Title',
  },
  {
    descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_RightPrice_Description',
    iconUrl: iconUrl('blocked-price', tenant),
    imageSize: iconSize[tenant],
    titleTranslationKey: 'priority:Priority_DetailPage_FloatingBanner_Bullet3',
  },
]

export const advantages: (tenant: Tenants) => CasavoAdvantage[] = (tenant) => {
  const adv = [
    tenant === TENANTS.casavo
      ? {
          descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Advance_Description',
          iconUrl: iconUrl('success-small', tenant),
          imageSize: iconSize[tenant],
          titleTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Advance_Title',
        }
      : {
          descriptionTranslationKey: 'unicredit:Priority_DetailPage_AdvantagesCard_Advance_Description',
          iconUrl: iconUrl('success-small', tenant),
          imageSize: iconSize[tenant],
          titleTranslationKey: 'unicredit:Priority_DetailPage_AdvantagesCard_Advance_Title',
        },
    {
      descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Waitlist_Description',
      iconUrl: iconUrl('appointment', tenant),
      imageSize: iconSize[tenant],
      titleTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Waitlist_Title',
    },
    tenant === TENANTS.casavo
      ? {
          descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_RightPrice_Description',
          iconUrl: iconUrl('blocked-price', tenant),
          imageSize: iconSize[tenant],
          titleTranslationKey: 'priority:Priority_DetailPage_FloatingBanner_Bullet3',
        }
      : undefined,
    {
      descriptionTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Support_Description',
      iconUrl: iconUrl('handshake', tenant),
      imageSize: iconSize[tenant],
      titleTranslationKey: 'priority:Priority_DetailPage_AdvantagesCard_Support_Title',
    },
  ]
  return adv.filter(Boolean)
}

export const getCharacteristics = (priority: Potential_Property, t: Translate): Characteristic[] => {
  return [
    {
      amount: priority.bathrooms,
      icon: 'bathroom',
      title: 'bathrooms',
      value: priority.bathrooms,
    },
    {
      amount: priority.balconies,
      icon: 'balcony',
      title: 'balconies',
      value: priority.balconies,
    },

    {
      amount: getTranslatedStateOfMaintenance(priority.stateOfMaintenance?.toLowerCase(), t),
      icon: null,
      title: 'status',
      value: priority.stateOfMaintenance,
    },
  ]
}

export const getRooms = (rooms: number): Characteristic => {
  return {
    amount: rooms,
    icon: 'rooms',
    title: 'rooms',
    value: rooms,
  }
}
